import React from 'react';
import {useSelector} from 'react-redux';
import {matchPath, useLocation, useNavigate} from 'react-router-dom';
import NavList from '../../ui/nav-list';
import NavListItem from '../../ui/nav-list-item';
import {checkRouteAccess} from '../../utils/helpers';
import useAuthenticatedRoutes from '../../hooks/use-authenticated-routes';

function SideNavFeature() {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const {asideShow} = useSelector(state => state.navigation);
  const {routes} = useAuthenticatedRoutes();

  const items = routes.filter(
    r => checkRouteAccess(r) && r.showInSideNav === true
  );

  const handleNavigate = path => {
    if (!path) {
      return;
    }
    navigate(path);
  };

  const renderItem = item => {
    const {slug, label, title, path, Icon = null, url = null} = item;
    const icon = Icon ? <Icon fontSize="inherit" /> : null;

    return (
      <NavListItem
        key={slug}
        title={title}
        label={label}
        open={asideShow}
        selected={Boolean(matchPath({path: `${path}/*`}, pathname))}
        onClick={e => handleNavigate(url || path, e)}
        icon={icon}
      />
    );
  };

  return <NavList expanded items={items} renderItem={renderItem} />;
}

export default SideNavFeature;
